// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner-spinner-RIK","staticSpinner":"Spinner-staticSpinner-3v2","label":"Spinner-label-SOG"};